import tw, { styled } from 'twin.macro'

export const MapWrapper = styled.div`
  ${tw`mx-auto`}
`
